import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const settingsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings',
    name: ROUTES.SETTINGS,
    component: () => import('@/modules/settings/views/SettingsIndex.view.vue'),
    redirect: { name: ROUTES.SETTINGS_BUSINESS },
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.SETTINGS_VIEW },
    children: [
      {
        path: 'business',
        name: ROUTES.SETTINGS_BUSINESS,
        component: () => import('@/modules/settings/views/BusinessSettings.view.vue'),
        beforeEnter: requireAuthenticatedUser,
        meta: { roles: ACTION_ROLES.SETTINGS_BUSINESS_VIEW }
      },
      {
        path: 'locations',
        name: ROUTES.SETTINGS_LOCATIONS,
        component: () => import('@/modules/settings/locations/views/LocationsIndex.view.vue'),
        beforeEnter: requireAuthenticatedUser,
        meta: { roles: ACTION_ROLES.SETTINGS_LOCATIONS_VIEW }
      },
      {
        path: 'salespoints',
        name: ROUTES.SETTINGS_SALESPOINTS,
        component: () => import('@/modules/settings/salespoints/views/SalespointsIndex.view.vue'),
        beforeEnter: requireAuthenticatedUser,
        meta: { roles: ACTION_ROLES.SETTINGS_SALESPOINTS_VIEW }
      },
      {
        path: 'printers',
        name: ROUTES.SETTINGS_PRINTERS,
        component: () => import('@/modules/settings/printers/views/PrintersIndex.view.vue'),
        beforeEnter: requireAuthenticatedUser,
        meta: { roles: ACTION_ROLES.SETTINGS_PRINTERS_VIEW }
      },
      {
        path: 'payment-terminals',
        name: ROUTES.SETTINGS_PAYMENT_TERMINALS,
        component: () => import('@/modules/settings/payment-terminals/views/PaymentTerminals.view.vue'),
        beforeEnter: requireAuthenticatedUser,
        meta: { roles: ACTION_ROLES.SETTINGS_PAYMENT_TERMINALS_VIEW }
      },
      {
        path: 'vessels',
        name: ROUTES.SETTINGS_VESSELS,
        component: () => import('@/modules/settings/views/VesselsSettings.view.vue'),
        beforeEnter: requireAuthenticatedUser,
        meta: { roles: ACTION_ROLES.SETTINGS_VESSELS_VIEW }
      },
      {
        path: 'online-sales',
        name: ROUTES.SETTINGS_ONLINE_SALES,
        component: () => import('@/modules/settings/views/OnlineSalesSettings.view.vue'),
        beforeEnter: requireAuthenticatedUser,
        meta: { roles: ACTION_ROLES.SETTINGS_ONLINE_SALES_VIEW }
      },
      {
        path: 'system',
        name: ROUTES.SETTINGS_SYSTEM,
        component: () => import('@/modules/settings/views/SystemSettings.view.vue'),
        beforeEnter: requireAuthenticatedUser,
        meta: { roles: ACTION_ROLES.SETTINGS_SYSTEM_VIEW }
      },
      {
        path: 'pos',
        name: ROUTES.SETTINGS_POS,
        component: () => import('@/modules/pos/views/PosSettings.view.vue'),
        beforeEnter: requireAuthenticatedUser,
        meta: { roles: ACTION_ROLES.SETTINGS_POS_VIEW }
      }
    ]
  }
]
